import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RappiderColorPickerComponent } from './color-picker.component';
import { RappiderButtonModule } from '../button/button.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  declarations: [
    RappiderColorPickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RappiderButtonModule,
    NzInputModule,
    ColorPickerModule,
    TranslateModule,
    NgxMaskModule.forChild()
  ],
  exports: [
    RappiderColorPickerComponent
  ]
})
export class RappiderColorPickerModule { }
